/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'Checked': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<defs><rect pid="0" id="svgicon_Checked_a" x="0" y="0" width="16" height="16" rx="1"/></defs><g _fill="none" fill-rule="evenodd"><mask id="svgicon_Checked_b" _fill="#fff"><use xlink:href="#svgicon_Checked_a"/></mask><g mask="url(#svgicon_Checked_b)"><path pid="1" d="M0 0h16v16H0z"/></g><path pid="2" d="M4.276 7.8a.746.746 0 00-1.08.06.812.812 0 00.057 1.118l3.027 2.819a.745.745 0 001.04-.018l5.445-5.416a.812.812 0 00.022-1.12.746.746 0 00-1.081-.022l-4.932 4.906L4.276 7.8z" _fill="#FFF" fill-rule="nonzero"/></g>'
  }
})
